import {
  MarketAccessory,
  MarketList,
  MarketRow,
} from '@market/react';
import type { ReactElement } from 'react';
import type { IconName } from '@squareup/shared-ui-react';
import EnvelopeArrowRight from '../assets/svgs/EnvelopeArrowRight';
import FileUpload from '../assets/svgs/FileUpload';
import type { ListProps } from '../components/page/product-page-header/ProductPageHeader';
import Plus from '../assets/svgs/Plus';

const listIconsMap: Partial<Record<IconName, ReactElement>> = {
  plus: <Plus />,
  'file-upload': <FileUpload />,
  'envelope-arrow-right': <EnvelopeArrowRight />,
};

export const buildMarketList = (list: ListProps | JSX.Element) => {
  if (list && typeof list === 'object' && 'options' in list) {
    const { className, slot, options } = list;
    return (<MarketList className={className} slot={slot || 'content'}>
      {options.map((options) => {
        const {
          key, icon, onClick, label,
        } = options;
        return (
          <MarketRow key={key || label} onClick={onClick}>
            {icon &&
              <MarketAccessory slot="leading-accessory" size="icon">
                {listIconsMap[icon]}
              </MarketAccessory>
            }
            <label>{label}</label>
          </MarketRow>);
      })}
    </MarketList>);
  }

  return list;
};
